import { Form, message } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import API from 'helpers/API';
import { getApiErrorMessage } from 'utils/getApiErrorMessage';
import ReclaimForm from '../../reclaims/ReclaimForm';

const Page = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [locations, setLocations] = useState([]);
  const [isLoadingForm, setIsLoadingForm] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const loadForm = async () => {
      setIsLoadingForm(true);
      const response = await API.get('/customer/reclaims/new-form');

      if (!isMounted) return;

      if (!response?.success) {
        message.error(getApiErrorMessage(response, '회수 요청 정보를 불러오지 못했습니다.'));
        setIsLoadingForm(false);
        return;
      }

      setLocations(response.data?.locations ?? []);
      form.setFieldsValue({
        reclaimDate: response.data?.reclaimDate
          ? dayjs(
              `${response.data.reclaimDate.slice(0, 4)}-${response.data.reclaimDate.slice(4, 6)}-${response.data.reclaimDate.slice(6, 8)}`,
            )
          : dayjs(),
        customerCompany: response.data?.customer?.name,
        customerName: response.data?.requester?.name,
        customerPhone: response.data?.requester?.phone,
      });
      setIsLoadingForm(false);
    };

    loadForm();

    return () => {
      isMounted = false;
    };
  }, [form]);

  const doSave = async (values) => {
    const data = {
      reclaimDate: values.reclaimDate.format('YYYYMMDD'),
      customerCompany: values.customerCompany,
      customerName: values.customerName,
      quantity: Number(values.quantity),
      reclaimLocationRid: values.reclaimLocationRid,
      customerAddress: values.customerAddress,
      customerAddressDetail: values.customerAddressDetail,
      customerPhone: values.customerPhone,
      memo: values.memo,
    };

    setIsSubmitting(true);

    const response = await API.post('/customer/reclaims', data);

    if (response?.success) {
      message.success('저장을 완료하였습니다.');
      navigate('/customer/reclaims');
      return;
    }

    message.error(getApiErrorMessage(response, '저장을 실패했습니다.'));
    setIsSubmitting(false);
  };

  return (
    <ReclaimForm
      title="회수하기"
      form={form}
      initialValues={{
        reclaimDate: dayjs(),
      }}
      locations={locations.map((location) => ({
        label: location.name,
        value: location.rid,
      }))}
      customerNameFieldType="input"
      isLoadingForm={isLoadingForm}
      isSubmitting={isSubmitting}
      onSubmit={doSave}
      onBack={() => navigate(-1)}
    />
  );
};

export default Page;
